﻿import React, { useState, useEffect } from 'react';
import { UserDataStore } from '../store/userDataStore';
import { ConductivityBenchSheet } from '../models/conductivity-bench-sheet';
import { SpotCheckBenchSheet } from '../models/spot-check-bench-sheet';
import { BenchSheetTechnologyType, NoteType, Entities } from '../models/enums';
import SecondaryBenchSheetInstrument from './SecondaryBenchSheetInstrument';
import QCCheckComponent from './QCCheckComponent';
import BenchSheetHeaderComponent from './BenchSheetHeaderComponent';
import NoteViewer from './NoteViewer';
import BenchSheetToolbar from './BenchSheetToolbar';
import { ItemBasicInformation } from '../models/item-basic-information';
import { DocumentationConstants } from '../store/documentation-constants';
import ItemBasicInformationDialog from './ItemBasicInformationDialog';
import TicketLogEntryForm from './TicketLogEntryForm';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import { CrudFunctions } from '../utilities/crud-functions';
import { FieldUpdate } from '../models/field-update';
import BasicReadingsData from './BasicReadingsData';
import DmaFooter from './DmaFooter';

import { Popup as DialogPopup } from 'devextreme-react/popup';
import SelectBox from 'devextreme-react/select-box';
import Button from 'devextreme-react/button';

//temp
const methodTypes = [
    { id: 1, name: "1413US" },
    { id: 2, name: "COND" },
    { id: 3, name: "Hach Conductivity" },
    { id: 4, name: "Hach Resistivity" },
    { id: 5, name: "Hach Salinity" },
    { id: 6, name: "Hach TDS" }
]

let key = 1;

export default function ConductivityBenchSheetForm() {
    const [benchSheet, setBenchSheet] =
        useState<ConductivityBenchSheet>();

    const [spotCheckBenchSheets, setSpotCheckBenchSheets] =
        useState<SpotCheckBenchSheet[]>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [ticketLogEntryDialogVisible, setTicketLogEntryDialogVisible] =
        useState<boolean>();

    const [itemBasicInitInformation, setItemBasicInitInformation] =
        useState<ItemBasicInformation>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [canEdit, setCanEdit] =
        useState<boolean>(false);

    //  const [initTabsComplete, setInitTabsComplete] =
    //    useState<boolean>();

    const [currentTab, setCurrentTab] =
        useState<string>();

    const [dataLoaded, setDataLoaded] =
        useState<boolean>();

    useEffect(() => {
        setAuthorizations();
        getAllData();
    }, []);

    useEffect(() => {
        initTabs();
    }, [spotCheckBenchSheets]);

    const parts = window.location.href.split('/');
    const benchSheetId = parts[parts.length - 1];

    const spotChecks = () => {
        if (!spotCheckBenchSheets)
            return null;

        let sc = spotCheckBenchSheets.map(s => s.sequence);

        return sc;
    }

    key++;

    return (
        <div className="pw-form-container">
            <div className="pw-content">
                <BenchSheetToolbar title="Conductivity Bench Sheet"
                    subtitle="Conductivity"
                    auditRowPointer={benchSheetId} entity={Entities.ConductivityBenchSheets}
                    technologyId={BenchSheetTechnologyType.Conductivity}
                    documentationId={DocumentationConstants.CONDBenchSheets}
                    showItemInformation={showBenchSheetInformationDialog}
                    showTicketLog={showTicketLogEntryDialog} />

                <BenchSheetHeaderComponent benchSheetId={benchSheetId} readOnly={!canEdit} />

                <div className="pw-comp-row">
                    <div className="pw-row-button-08">
                        <Button id="addSpotCheckButton" disabled={!canEdit}
                            text="Add Spot Check" type="success"
                            hint="add spot checks"
                            onClick={onAddSpotCheckClick} />
                    </div>

                    <div className="pw-row-button-08 pw-margin-left-05">
                        <Button id="removeSpotCheckButton" disabled={!canEdit}
                            text="Remove Spot Check" type="normal"
                            hint="remove spot checks"
                            onClick={onRemoveSpotCheckClick} />
                    </div>
                </div>

                <div id="pb-navigation-pane" >
                    <div id="tab-buttons-panel" className="tab-buttons-container">
                        <div id="qcPanelButton" onClick={onPanelButtonClick}>QC</div>

                        {spotCheckBenchSheets && spotCheckBenchSheets.map((item, i) =>
                            <div key={i.toString()} id={`spotCheckPanelButton${item.sequence}`} onClick={onPanelButtonClick}>{`Spot Check ${item.sequence}`}</div>)}

                    </div>
                </div>

                <div id="qcPanel" className="pw-form-section">
                    <div className="pw-comp-row">
                        <div className="pw-form-unit pw-comp-20">
                            <div className="pw-form-unit-label">Method</div>
                            <SelectBox id="methodId"
                                className="selectbox"
                                placeholder='NA' readOnly={!canEdit}
                                displayExpr='name' valueExpr='id'
                                dataSource={methodTypes ? methodTypes : []}
                                onValueChanged={onValueChanged}
                                value={benchSheet && benchSheet.methodId ?
                                    benchSheet.methodId : null} />
                        </div>
                    </div>

                    <SecondaryBenchSheetInstrument isReadOnly={!canEdit}
                        benchSheetId={benchSheetId}
                        technology={BenchSheetTechnologyType.Conductivity}
                        title="Conductivity Instrument" />

                    <QCCheckComponent benchSheetId={benchSheetId} isReadOnly={!canEdit}
                        technologyId={BenchSheetTechnologyType.Conductivity}
                        datagridHeight='12rem' title='Conductivity QC Checks' />

                    <BasicReadingsData benchSheetId={benchSheetId} isReadOnly={!canEdit}
                        title='Conductivity Readings' />

                </div>

                <div>{spotCheckBenchSheets && spotCheckBenchSheets.map((item, i) =>
                    <div id={`spotCheckPanel${item.sequence}`} key={i.toString()} className="pw-form-section">

                        <div className="pw-form-unit lq-sub-title pw-margin-top-05 pw-margin-bottom-05">{`Spot Check #${item.sequence}`}</div>

                        <div className="pw-comp-row">
                            <div className="pw-form-unit pw-comp-20">
                                <div className="pw-form-unit-label">Method</div>
                                <SelectBox id={`methodId_${item.sequence}`}
                                    className="selectbox"
                                    placeholder='NA' readOnly={!canEdit}
                                    displayExpr='name' valueExpr='id'
                                    dataSource={methodTypes ? methodTypes : []}
                                    onValueChanged={onSpotCheckValueChanged}
                                    value={item.methodId ?
                                        item.methodId : null} />
                            </div>
                        </div>

                        <SecondaryBenchSheetInstrument isReadOnly={!canEdit}
                            benchSheetId={benchSheetId}
                            spotCheckBenchSheetId={item.spotCheckBenchSheetId}
                            technology={BenchSheetTechnologyType.Conductivity}
                            title={`Conductivity Instrument (Spot Check #${item.sequence})`} />

                        <QCCheckComponent benchSheetId={benchSheetId} isReadOnly={!canEdit}
                            spotCheckBenchSheetId={item.spotCheckBenchSheetId}
                            technologyId={BenchSheetTechnologyType.Conductivity}
                            datagridHeight='12rem' title={`Conductivity QC Checks (Spot Check #${item.sequence})`} />

                        <BasicReadingsData benchSheetId={benchSheetId} isReadOnly={!canEdit}
                            spotCheckBenchSheetId={item.spotCheckBenchSheetId}
                            title={`Conductivity Readings (Spot Check #${item.sequence})`} />
                    </div>
                )}
                </div>

                <div className="pw-comp-row-scroll-fixed-grid">
                    <NoteViewer height='10rem' title="Bench Sheet Note"
                        noteType={NoteType.Method} parentId={benchSheetId} />
                </div>

            </div>

            <DmaFooter />

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInitInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {ticketLogEntryDialogVisible &&
                <DialogPopup visible={ticketLogEntryDialogVisible}
                    onHiding={hideTicketLogEntryDialog}
                    title="Ticket Log Entry"
                    width={'55rem'}
                    height={'45rem'}
                    dragEnabled={true}
                    resizeEnabled={true}>
                    <TicketLogEntryForm formName="Conductivity Bench Sheet" contextData={benchSheet}
                        onCancel={hideTicketLogEntryDialog}
                        onComplete={hideTicketLogEntryDialog}
                        key={`TLE${key}`} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    function setAuthorizations() {
        const user = UserDataStore.getCurrentUser();

        const canEditRoles = ["SA", "MF-A", "MF-L", "MF-T", "PP-A", "PP-L", "PP-T", "DIST-A", "BA-A", "QCP-A", "QCD-A", "RD-A", "RD-L", "RD-T"];
        const canEdit = canEditRoles.some(r => user.roleCodes && user.roleCodes.includes(r));

        setCanEdit(canEdit);
    }

    async function onAddSpotCheckClick() {
        const spotCheckCount = spotChecks && spotChecks.length > 0 ? spotChecks.length : 0;

        const newSpotCheckBenchSheet: SpotCheckBenchSheet = {
            benchSheetId: benchSheetId,
            sequence: spotCheckCount + 1,
        };

        await insertSpotCheckBenchSheet(newSpotCheckBenchSheet)
            .then(() => {

                getSpotCheckBenchSheets();
                /*
                let newSpotChecks = spotChecks ? [...spotChecks] : [];
                newSpotChecks.push(spotCheckCount + 1);
                setSpotChecks(newSpotChecks);
                */
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Adding Spot Check");
            });
    }

    function onRemoveSpotCheckClick() {

        /*
        let newSpotChecks = [...spotChecks];

        newSpotChecks.pop();

        setSpotChecks(newSpotChecks);
        */
    }

    async function onValueChanged(e: any) {
        if (!dataLoaded)
            return;

        const caller = e.element.id as string;

        if (caller && benchSheet) {
            const bs = benchSheet as any;
            const currentValue = bs[caller];

            if (currentValue === e.value)
                return;
            else if (!currentValue && !e.value)
                return;
            else {
                setBenchSheet({ ...benchSheet, [caller]: e.value });

                let fieldUpdate: FieldUpdate = {
                    entity: "ConductivityBenchSheets",
                    field: caller,
                    value: e.value,
                    rowId: benchSheetId
                };

                await updateField(fieldUpdate)
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Field");
                    });
            }
        }
    }

    async function onSpotCheckValueChanged(e: any) {
        //console.log("onSpotCheckValueChanged.....")

        if (!dataLoaded)
            return;

        const indexedCaller = e.element.id as string;

        if (!indexedCaller.includes("_"))
            return;

        const undIdx = indexedCaller.indexOf('_');
        const spotCheckSequence = parseInt(indexedCaller.substring(undIdx + 1));
        const caller = indexedCaller.substring(0, undIdx);

        let currentSpotCheckBenchSheets = [...spotCheckBenchSheets];
        let selectedSpotCheckBenchSheet = currentSpotCheckBenchSheets.find(s => s.sequence === spotCheckSequence);

        if (selectedSpotCheckBenchSheet) {
            const currentValue = selectedSpotCheckBenchSheet[caller];

            if (currentValue === e.value)
                return;
            else if (!currentValue && !e.value)
                return;
            else {
                selectedSpotCheckBenchSheet[caller] = e.value;

                setSpotCheckBenchSheets(currentSpotCheckBenchSheets);

                let fieldUpdate: FieldUpdate = {
                    entity: "SpotCheckBenchSheets",
                    field: caller,
                    value: e.value,
                    rowId: selectedSpotCheckBenchSheet.benchSheetId
                };

                await updateField(fieldUpdate)
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Field");
                    });
            }
        }
    }

    //GET methods

    async function getBenchSheet() {
        await CrudFunctions.getData(`benchsheets/benchsheet/${benchSheetId}`)
            .then(data => {
                console.log(data);

                setBenchSheet(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Bench Sheet");
            });
    }

    async function getSpotCheckBenchSheets() {
        await CrudFunctions.getData(`benchsheets/spotcheckbenchsheets/${benchSheetId}`)
            .then(data => {

                console.log("spot check BS:");
                console.log(data);


                setSpotCheckBenchSheets(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Spot Checks");
            });
    }

    // PUT functions

    async function updateField(fieldUpdate: FieldUpdate) {
        return CrudFunctions.putData("benchsheets/conductivitybenchsheetfield", fieldUpdate);
    }

    async function insertSpotCheckBenchSheet(spotCheckBenchSheet: SpotCheckBenchSheet) {
        return CrudFunctions.postData("benchsheets/spotcheckbenchsheet", spotCheckBenchSheet);
    }

    // other functions
    async function getAllData() {
        await Promise.all([
            getSpotCheckBenchSheets(),
            getBenchSheet()
        ])
            .then(() => {
                // initTabs();
                setDataLoaded(true);
            });
    }

    // show/hide

    function showTicketLogEntryDialog() {
        setTicketLogEntryDialogVisible(true);
    }

    function hideTicketLogEntryDialog() {
        setTicketLogEntryDialogVisible(false);
    }

    function showBenchSheetInformationDialog() {
        if (benchSheet) {
            let itemBasicInitInformation: ItemBasicInformation = {
                rowPointer: benchSheet.benchSheetId,
                createTimestamp: benchSheet.createTimestamp,
                lastModifiedTimestamp: benchSheet.modifyTimestamp,
                createUser: benchSheet.createUser,
                modifyUser: benchSheet.modifyUser
            };

            setItemBasicInitInformation(itemBasicInitInformation);
            setItemBasicInformationDialogVisible(true);
        }
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    function onPanelButtonClick(e: any) {
        if (e.target && e.target.id)
            setCurrentTab(e.target.id);

        resetAllButtons();

        const button = e.target as HTMLDivElement;

        if (button) {
            button.className = "tab-button-active";
        }

        hideAllComponents();

        const id: string = e.target.id;
        const panel = document.getElementById(id.replace("Button", "")) as HTMLDivElement;
        panel.style.display = "";
    }

    function resetAllButtons() {
        const qcPanelButton = document.getElementById("qcPanelButton") as HTMLDivElement;
        qcPanelButton.className = "tab-button-inactive";

        if (spotCheckBenchSheets) {
            spotCheckBenchSheets.forEach(sc => {
                const spotCheckButton = document.getElementById(`spotCheckPanelButton${sc.sequence}`) as HTMLDivElement;
                if (spotCheckButton)
                    spotCheckButton.className = "tab-button-inactive";
            });
        }
    }

    function hideAllComponents(onload: boolean = false) {
        if (!onload) {
            const qcPanel = document.getElementById("qcPanel") as HTMLDivElement;
            qcPanel.style.display = "none";
        }

        if (spotCheckBenchSheets) {
            spotCheckBenchSheets.forEach(sc => {
                const spotCheckPanel = document.getElementById(`spotCheckPanel${sc.sequence}`) as HTMLDivElement;
                if (spotCheckPanel)
                    spotCheckPanel.style.display = "none";
            });
        }
    }

    function initTabs() {
        //if (initTabsComplete)
        //  return;

        hideAllComponents(true);

        const qcPanelTab = document.getElementById(currentTab ? currentTab : "qcPanelButton") as HTMLDivElement;
        qcPanelTab.click();

        //setInitTabsComplete(true);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

}
